import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError } from 'rxjs/operators';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(
    private http: HttpClient,
    private zone: NgZone
  ) {}

  urlApiManagement = environment.urlApiManagement;

  login(email: string, password: string) {
    const url = `${this.urlApiManagement}/api/v1/logins`;

    const body = {
      user: email,
      password: password,
      code: null,
      expiring: null
    };

    return this.http.post(url, body).pipe(catchError(this.handleError('login()')));
  }

  expire(email: string, flag: string) {
    const url = `${this.urlApiManagement}/api/v1/logins/expire/set-flag`;

    const body = {
      email: email,
      expiring: flag
    };

    return this.http.post(url, body).pipe(catchError(this.handleError('login()')));
  }

  checkExpiring(email: string) {
    const url = `${this.urlApiManagement}/api/v1/logins/expired/${email}`;
    return this.http.get(url).pipe(catchError(this.handleError('checkExpiring()')));
  }

  validateUserLogin(email: string) {
    const url = `${this.urlApiManagement}/api/v1/logins/login/${email}`;
    return this.http.get(url, {}).pipe(catchError(this.handleError('validateUserLogin()')));
  }

  validateCode(email: string, code: any) {
    const url = `${this.urlApiManagement}/api/v1/logins/validate-code`;

    const body = {
      user: email,
      code: code
    };

    return this.http.post(url, body).pipe(catchError(this.handleError('validateCode()')));
  }

  createPassword(email: string, password: string) {
    const url = `${this.urlApiManagement}/api/v1/logins/create-login`;

    const body = {
      user: email,
      password: password,
      code: null,
      expiring: null
    };

    return this.http.post(url, body).pipe(catchError(this.handleError('create()')));
  }

  updatePassword(email: string, password: string) {
    const url = `${this.urlApiManagement}/api/v1/logins/update-login`;

    const body = {
      user: email,
      password: password,
      code: null,
      expiring: null
    };

    return this.http.post(url, body).pipe(catchError(this.handleError('updatePassword()')));
  }

  generateCode(email: string) {
    const url = `${this.urlApiManagement}/api/v1/logins/generate-code/${email}`;
    return this.http.get(url, {}).pipe(catchError(this.handleError('generateCode()')));
  }

  handleError(error: any) {
    if (!(error instanceof HttpErrorResponse)) {
      return (error = error.rejection);
    }

    this.zone.run(() => console.log('Message: ', error?.message, 'Error: ', error?.status));

    return console.error('Error from global error handler', error);
  }
}
